import angular from 'angular';

const BODACDC_167 = FEATURE_BODACDC_167;
const BODACDC_2405 = FEATURE_BODACDC_2405;
const BODACDC_3966 = FEATURE_BODACDC_3966;

export const states = {
  // 'styleguide': {
  //   url: '/styleguide',
  //   templateUrl: 'app/views/styleguide/styleguide.html',
  //   controller: 'StyleguideController',
  //   controllerAs: 'styles',
  //   authenticate: false
  // },

  /* Auth States */
  login: BODACDC_167
    ? {
        url: '/',
        pageTitle: 'Login',
        template: '<pims-login></pims-login>',
        authenticate: false,
        blockWhenAuthenticated: true,
      }
    : {
        url: '/',
        pageTitle: 'Login',
        templateUrl: 'app/views/auth/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        authenticate: false,
        blockWhenAuthenticated: true,
      },
  forgotPassword: {
    url: '/forgot-password',
    pageTitle: 'Forgot Password',
    templateUrl: 'app/views/auth/forgot/forgot-password.html',
    controller: 'ForgotPasswordController',
    controllerAs: 'vm',
    authenticate: false,
    blockWhenAuthenticated: true,
  },
  resetPassword: {
    url: '/reset-password',
    pageTitle: 'Reset Password',
    templateUrl: 'app/views/auth/reset/reset-password.html',
    controller: 'ResetPasswordController',
    controllerAs: 'vm',
    authenticate: false,
    blockWhenAuthenticated: true,
  },
  visits: {
    url: '/visits',
    pageTitle: 'Visits',
    templateUrl: 'app/views/visits/list/visits.html',
    controller: 'VisitsController',
    controllerAs: 'vm',
    authenticate: true,
  },
  visitsWaitingRoom: {
    url: '/visits/waiting-room',
  },
  visitsBatching: {
    url: '/visits/batching',
  },
  visitsRxHub: {
    url: '/visits/rx-hub',
  },
  visitsAppointments: {},
  visitsMailOrder: {
    url: '/visits/mail-order',
  },
  visitsVisitHistory: {
    url: '/visits/visit-history',
  },
  visitsPharmacy: {
    url: '/visits/pharmacy',
  },
  visitsOutbound: {
    url: '/visits/outbound',
  },
  visitsScanwellTestKitResult: {
    url: '/visits/scanwell-test-kit-result',
  },
  visitsScanwellTestKitShipping: {
    url: '/visits/scanwell-test-kit-shipping',
  },
  visitsScanwellUnmatchedData: {
    url: '/visits/scanwell-unmached-data',
  },
  visitsPatientSupportFollowup: {
    url: '/visits/patient-support-followup',
  },
  visitDetail: {
    url: '/visits/:id?tab',
    pageTitle: 'Visit :id',
    templateUrl: 'app/views/visits/detail/visit.html',
    controller: 'VisitController',
    controllerAs: 'vm',
    authenticate: true,
  },
  messages: BODACDC_3966
    ? {
        url: '/messages',
        authenticate: true,
        pageTitle: 'Messages',
        onEnter: [
          '$injector',
          $injector => {
            const ngRouter = $injector.get('NgRouter');
            ngRouter.navigate(['/messages']);
          },
        ],
        onExit: [
          '$injector',
          $injector => {
            const ngRouter = $injector.get('NgRouter');
            ngRouter.navigate(['/']);
          },
        ],
      }
    : {
        url: '/messages',
        pageTitle: 'Messages',
        templateUrl: 'app/views/messages/messages.html',
        controller: 'MessagePoolController',
        controllerAs: 'vm',
        authenticate: true,
      },
  newUser: {
    url: '/users/new',
    pageTitle: 'New User',
    templateUrl: 'app/views/users/new/newUserOld.html',
    controller: 'NewUserController',
    controllerAs: 'vm',
    authenticate: true,
  },
  userDetail: {
    url: '/users/:id',
    pageTitle: 'User :id',
    templateUrl: 'app/views/users/detail/user.html',
    controller: 'UserController',
    controllerAs: 'vm',
    authenticate: true,
  },
  users: {
    url: '/users',
    pageTitle: 'Users',
    templateUrl: 'app/views/users/list/users.html',
    controller: 'UsersController',
    controllerAs: 'vm',
    authenticate: true,
  },
  gpLetters: {
    url: '/gp-letters',
    pageTitle: 'GP Letters',
    templateUrl: 'app/views/users/gp-letters/gp-letters.component.html',
    controller: 'GpLetters',
    controllerAs: 'vm',
    authenticate: true,
    abstract: true,
  },
  'gpLetters.unverified_addresses': {
    url: '/unverified_addresses?search&number&limit',
    pageTitle: 'Unverified Addresses',
    templateUrl: 'app/views/users/gp-letters/tabs/unverified-address/unverified-address.component.html',
    controller: 'UnverifiedAddress',
    controllerAs: 'vm',
    authenticate: true,
    params: {
      search: '',
      number: '1',
      limit: '50',
    },
  },
  'gpLetters.pending_letters': {
    url: '/pending_letters?search&number&limit',
    pageTitle: 'Pending GP Letters',
    templateUrl: 'app/views/users/gp-letters/tabs/pending-gp-letters/pending-gp-letters.component.html',
    controller: 'PendingGpLetters',
    controllerAs: 'vm',
    authenticate: true,
    params: {
      search: '',
      number: '1',
      limit: '50',
    },
  },
  'gpLetters.incomplete_addresses': {
    url: '/incomplete-addresses?search&number&limit',
    pageTitle: 'Incomplete GP addresses',
    templateUrl: 'app/views/users/gp-letters/tabs/incomplete-addresses/incomplete-addresses.component.html',
    controller: 'IncompleteGpAddresses',
    controllerAs: 'vm',
    authenticate: true,
    params: {
      search: '',
      number: '1',
      limit: '50',
    },
  },
  'gpLetters.unresponsive_patients': {
    url: '/unresponsive-patients?search&number&limit&services',
    pageTitle: 'Unresponsive Patients',
    templateUrl: 'app/views/users/gp-letters/tabs/unresponsive-patient/unresponsive-patients.component.html',
    controller: 'UnresponsivePatients',
    controllerAs: 'vm',
    authenticate: true,
    params: {
      search: '',
      number: '1',
      limit: '50',
      services: '',
    },
  },
  staffUserDetail: {
    url: '/staff-users/:id',
    pageTitle: 'GP Letters',
    templateUrl: 'app/views/staffusers/detail/staffuserOld.html',
    controller: 'StaffUserController',
    controllerAs: 'vm',
    authenticate: true,
  },
  staffUsers: {
    url: '/staff-users',
    pageTitle: 'Staff Users',
    templateUrl: 'app/views/staffusers/list/staffusers.html',
    controller: 'StaffUsersController',
    controllerAs: 'vm',
    authenticate: true,
  },
  // CMS
  cms: {
    url: '/cms',
    abstract: true,
    template: '<ui-view />',
  },
  'cms.services': {
    url: '',
    templateUrl: 'app/views/services/list/service-list.html',
    controller: 'ServiceListController',
    controllerAs: 'vm',
    authenticate: true,
    pageTitle: 'Services',
  },
  'cms.service': {
    url: '/:serviceId',
    templateUrl: 'app/views/services/detail/service-detail.html',
    controller: 'ServiceDetailController',
    controllerAs: 'vm',
    authenticate: true,
    pageTitle: 'Service :serviceId',
    crumbs: [
      {
        state: 'cms.services',
        title: 'Services',
      },
      {
        title: 'Service :serviceId',
      },
    ],
  },
  // 'cms.tasks': {
  //   url: '/:serviceCode/tasks',
  //   pageTitle: ':serviceCode Tasks',
  //   templateUrl: 'app/views/services/tasks/tasks.html',
  //   controller: 'TasksController',
  //   controllerAs: 'vm',
  //   authenticate: true,
  //   crumbs: [{
  //     state: 'cms.services',
  //     title: 'Services'
  //   }, {
  //     title: 'Tasks'
  //   }]
  // },
  // 'cms.questionnaire': {
  //   url: '/:serviceCode/tasks/questionnaire',
  //   pageTitle: ':serviceCode Questionnaires',
  //   templateUrl: 'app/views/services/questionnaire/questionnaire.list.html',
  //   controller: 'QuestionnaireListController',
  //   controllerAs: 'vm',
  //   authenticate: true,
  //   crumbs: [{
  //     state: 'cms.services',
  //     title: 'Services'
  //   }, {
  //     state: 'cms.tasks',
  //     title: 'Tasks'
  //   }, {
  //     title: 'Questionnaires'
  //   }]
  // },
  'cms.questionnaireDetail': {
    url: '/:serviceId/questionnaire/:questionnaireId',
    pageTitle: 'Questionnaire :questionnaireId',
    templateUrl: 'app/views/services/questionnaire/questionnaire.detail.html',
    controller: 'QuestionnaireDetailController',
    controllerAs: 'vm',
    authenticate: true,
    crumbs: [
      {
        state: 'cms.services',
        title: 'Services',
      },
      {
        state: 'cms.service',
        title: 'Service :serviceId',
      },
      {
        title: 'Questionnaire :questionnaireId',
      },
    ],
  },
  promos: {
    url: '/promotions',
    pageTitle: 'Promos',
    templateUrl: 'app/views/settings/promos/list/promo-list.html',
    controller: 'PromoListController',
    controllerAs: 'vm',
    authenticate: true,
  },
  newPromo: {
    url: '/promotions/new',
    pageTitle: 'New Promo',
    templateUrl: 'app/views/settings/promos/new/new-promo.html',
    controller: 'NewPromoController',
    controllerAs: 'vm',
    authenticate: true,
    crumbs: [
      {
        state: 'promos',
        title: 'Promotions',
      },
      {
        title: 'New',
      },
    ],
  },
  promoDetail: {
    url: '/promotions/:id',
    pageTitle: 'Promo :id',
    templateUrl: 'app/views/settings/promos/detail/promo-detail.html',
    controller: 'PromoDetailController',
    controllerAs: 'vm',
    authenticate: true,
    crumbs: [
      {
        state: 'promos',
        title: 'Promotions',
      },
      {
        title: ':id',
      },
    ],
  },
  settings: {
    url: '/settings',
    pageTitle: 'Settings',
    templateUrl: 'app/views/settings/settings.html',
    controller: 'SettingsController',
    controllerAs: 'vm',
    abstract: true,
  },
  'settings.prescription-key': {
    url: '/prescription-key',
    pageTitle: 'Prescription Key Management',
    templateUrl: 'app/views/settings/prescription-key/prescription-key.html',
    controller: 'PrescriptionKeyController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.schedule': {
    url: '/schedule',
    pageTitle: 'Schedule',
    templateUrl: 'app/views/settings/schedule/schedule.html',
    controller: 'ScheduleController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.appointment-scheduling': {
    url: '/appointment-scheduling',
    pageTitle: 'Appointment Scheduling',
    templateUrl: 'app/views/settings/appointment-scheduling/appointment-scheduling.html',
    controller: 'AppointmentSchedulingController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.slv': {
    url: '/slv',
    pageTitle: 'SLV',
    templateUrl: 'app/views/settings/slv/slv-config.html',
    controller: 'SLVConfigController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.batching-rules': BODACDC_2405
    ? {
        url: '/batching-rules',
        authenticate: true,
        pageTitle: 'Batching Rules',
        onEnter: [
          '$injector',
          $injector => {
            const ngRouter = $injector.get('NgRouter');
            ngRouter.navigate(['/settings/batching-rules']);
          },
        ],
        onExit: [
          '$injector',
          $injector => {
            const ngRouter = $injector.get('NgRouter');
            ngRouter.navigate(['/']);
          },
        ],
      }
    : {
        url: '/batching-rules',
        pageTitle: 'Batching Rules',
        templateUrl: 'app/views/settings/batching-rules/batching-rules.component.html',
        controller: 'BatchingRules',
        controllerAs: 'vm',
        authenticate: true,
      },
  'settings.provider-modality': {
    url: '/provider-modality',
    pageTitle: 'Provider Modality',
    templateUrl: 'app/views/settings/provider-modality/provider-modality.html',
    controller: 'ProviderModalityController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.config': {
    url: '/config',
    pageTitle: 'Config',
    templateUrl: 'app/views/settings/config/admin-config.html',
    controller: 'AdminConfigController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.redis-cache': {
    url: '/redis-cache',
    pageTitle: 'Service Cache',
    templateUrl: 'app/views/settings/redis-cache/redis-cache.html',
    controller: 'RedisCacheController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.slv-toggle': {
    url: '/slv-toggle',
    pageTitle: 'SLV Toggle',
    templateUrl: 'app/views/settings/slv-toggle/slv-toggle-config.html',
    controller: 'SLVToggleController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.medication-price': {
    url: '/medication-price',
    pageTitle: 'Edit Medication Price',
    templateUrl: 'app/views/settings/medication-price/medication-price.html',
    controller: 'MedicationPriceController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.mail-order-pharmacies': {
    url: '/mail-order-pharmacies',
    pageTitle: 'Mail Order Pharmacies',
    templateUrl: 'app/views/settings/mail-order-pharmacies/mail-order-pharmacies.html',
    controller: 'MailOrderPharmaciesController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.visit-discounts': {
    url: '/visit-discounts',
    pageTitle: 'Visit Discounts',
    templateUrl: 'app/views/settings/visit-discount/visit-discount.html',
    controller: 'VisitDiscountController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.medications': {
    url: '/medications-list',
    pageTitle: 'Medications',
    templateUrl: 'app/views/settings/medications/medications.html',
    controller: 'MedicationsListController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.products': {
    url: '/products',
    pageTitle: 'Products',
    templateUrl: 'app/views/settings/products/products.html',
    controller: 'ProductsController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.groups': {
    url: '/groups',
    pageTitle: 'Product groups',
    templateUrl: 'app/views/settings/groups/groups.html',
    controller: 'GroupsController',
    controllerAs: 'vm',
    authenticate: true,
  },
  'settings.refill-discounts': {
    url: '/refill-discounts',
    pageTitle: 'Refill Discounts',
    templateUrl: 'app/views/settings/refill-discount/refill-discount.html',
    controller: 'RefillDiscountController',
    controllerAs: 'vm',
    authenticate: true,
  },
  treatments: {
    url: '/medications/:id',
    pageTitle: 'Medications',
    templateUrl: 'app/views/plans/medications/medications.html',
    controller: 'MedicationsController',
    controllerAs: 'vm',
    authenticate: true,
  },
  treatment: {
    url: '/pages/:id',
    pageTitle: 'Treatment',
    templateUrl: 'app/views/plans/treatment/treatment.html',
    controller: 'TreatmentController',
    controllerAs: 'vm',
    authenticate: true,
  },
};

const router = ($locationProvider, $stateProvider, $urlRouterProvider) => {
  'ngInject';

  /* Register our states */

  for (const state in states) {
    $stateProvider.state(state, states[state]);
  }

  $urlRouterProvider.otherwise($injector => {
    //$injector.get('$state').go('login');
  }); // Remove hashbangs from the URL

  $locationProvider.html5Mode(true);
};

router.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider'];
angular.module('pims').config(router);
